import React from 'react';
import { IonText } from '@ionic/react';
import MeetingCard from './MeetingCard';

interface IProps {
    meetings: any[];
}

const Meetings: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.meetings) && props.meetings.map((meeting, index) => <MeetingCard meeting={meeting} key={index} />)}
            {(!Array.isArray(props.meetings) || props.meetings.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No meetings found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Meetings;
